<template>
  <div class="detail_content">
    <div class="total_period_label assessment_title_label">
      {{ titleLabel }}
    </div>
    <div :class="nameValue" class="detail_content">
      <div class="tenant_radio_buttons">
        <label>
          <input
            type="radio"
            class="tenant_radio_button"
            :name="nameValue"
            :value="locationlabel"
            @click="changeRateFlag(false)"
            disabled
          />
          {{ locationlabel }}
        </label>
        <label>
          <input
            type="radio"
            class="tenant_radio_button"
            :name="nameValue"
            :value="ratelabel"
            @click="changeRateFlag(true)"
            checked
          />
          {{ ratelabel }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleLabel: String
  },
  data() {
    return {
      locationlabel: '位置情報ログ',
      ratelabel: '業務評価ログ',
      nameValue: 'target'
    }
  },
  computed: {},
  methods: {
    changeRateFlag(value) {
      this.$store.dispatch('masters/changeRateFlag', value)
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/logExportCompornents/targetSection.vue